(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bbc-article-2026"]) return;
  try {
    
/* Reading-progress bar - scales with scroll through the article body. */
(function () {
  var bar = document.querySelector('.art-progress i');
  var body = document.querySelector('.art-prose');
  if (!bar || !body) return;
  var ticking = false;
  function update() {
    var r = body.getBoundingClientRect();
    var vh = window.innerHeight;
    var total = r.height - vh;
    var done = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : (r.top < vh ? 1 : 0);
    bar.style.transform = 'scaleX(' + done + ')';
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
  update();
})();

/* QUOTE PROMOTION - a paragraph that both opens and closes with quotation marks
   (optional "- attribution" tail) IS a quote; editors paste them as plain <p>.
   Promotes to the quote-card treatment and splits the attribution into a cite
   line. Runs only inside the prose; anything else is left alone. */
(function () {
  var prose = document.querySelector('.art-prose');
  if (!prose) return;
  [].slice.call(prose.querySelectorAll(':scope > p')).forEach(function (p) {
    if (p.querySelector('img,iframe,video')) return;
    var m = p.textContent.trim().match(/^[“"](.+)[”"]\s*(?:[—–-]{1,2}\s*(.+))?$/s);
    if (!m) return;
    p.classList.add('art-q');
    var quote = m[1].trim(), cite = (m[2] || '').trim();
    while (p.firstChild) p.removeChild(p.firstChild);
    var qt = document.createElement('span');
    qt.className = 'art-q-t';
    qt.textContent = '“' + quote + '”';
    p.appendChild(qt);
    if (cite) {
      var c = document.createElement('span');
      c.className = 'art-q-c';
      c.textContent = cite;
      p.appendChild(c);
    }
  });
})();

/* LINK BOX - a list where most items carry a URL (as an anchor or pasted as bare
   text) becomes a forest panel of link cards. Bare URLs are linkified; labels
   live in spans so the estate anchor rule cannot repaint them on the dark box. */
(function () {
  var prose = document.querySelector('.art-prose');
  if (!prose) return;
  var URLRE = /https?:\/\/[^\s<)]+/;
  [].slice.call(prose.querySelectorAll(':scope > ul, :scope > ol')).forEach(function (list) {
    var items = [].slice.call(list.children).filter(function (li) { return li.tagName === 'LI'; });
    if (!items.length) return;
    var linky = items.filter(function (li) {
      return li.querySelector('a[href^="http"]') || URLRE.test(li.textContent);
    });
    if (linky.length < items.length || linky.length < 1) return;
    list.classList.add('art-linkbox');
    items.forEach(function (li) {
      var url = '', label = '';
      var a = li.querySelector('a[href^="http"]');
      if (a) {
        url = a.getAttribute('href');
        label = li.textContent.replace(URLRE, '').replace(/[—–-]\s*$/, '').trim() || a.textContent.trim() || url;
      } else {
        var mm = li.textContent.match(URLRE);
        if (!mm) return;
        url = mm[0].replace(/[).,]+$/, '');
        label = li.textContent.replace(URLRE, '').replace(/\s*[—–-]\s*$/, '').trim() || url;
      }
      var host = '';
      try { host = new URL(url).hostname.replace(/^www\./, ''); } catch (e) {}
      while (li.firstChild) li.removeChild(li.firstChild);
      var link = document.createElement('a');
      link.className = 'art-lb';
      link.setAttribute('href', url);
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener');
      var lt = document.createElement('span');
      lt.className = 'art-lb-t';
      lt.textContent = label;
      var ld = document.createElement('span');
      ld.className = 'art-lb-d';
      ld.textContent = host ? host + ' ↗' : '↗';
      link.appendChild(lt); link.appendChild(ld);
      li.appendChild(link);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bbc-collection-2026"] && !Shopify.designMode) return;
  try {
    
/* Kits hero film - the estate's hardened pattern (start on canplay, reveal on
   playing; gates leave the flatlay photo). */
(function () {
  var v = document.querySelector('.kvh-film');
  if (!v) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  /* phone gate removed 2026-08-24 - James: hero films must play on mobile too */
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;
  v.muted = true; v.defaultMuted = true;
  function start() { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  v.addEventListener('playing', function () { v.classList.add('is-on'); }, { once: true });
  function go() {
    v.setAttribute('preload', 'auto');
    v.load();
    if (v.readyState >= 3) start();
    else v.addEventListener('canplay', start, { once: true });
  }
  /* 2026-09-23 (speed): start the film only after the page has loaded, so the hero photo is the
     largest paint and the ~3.5 MB film no longer competes with it. Films still play on phones. */
  function later() { setTimeout(go, 1200); }
  if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { v.pause(); }
    else if (v.classList.contains('is-on')) { start(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bbc-contact-2026"] && !Shopify.designMode) return;
  try {
    
/* Contact hero film - the estate's hardened pattern. */
(function () {
  var v = document.querySelector('.cvh-film');
  if (!v) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  /* phone gate removed 2026-08-24 - James: hero films must play on mobile too */
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;
  v.muted = true; v.defaultMuted = true;
  function start() { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  v.addEventListener('playing', function () { v.classList.add('is-on'); }, { once: true });
  function go() {
    v.setAttribute('preload', 'auto');
    v.load();
    if (v.readyState >= 3) start();
    else v.addEventListener('canplay', start, { once: true });
  }
  /* 2026-09-23 (speed): start the film only after the page has loaded, so the hero photo is the
     largest paint and the ~3.5 MB film no longer competes with it. Films still play on phones. */
  function later() { setTimeout(go, 1200); }
  if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { v.pause(); }
    else if (v.classList.contains('is-on')) { start(); }
  });
})();

/* Enquiry context: progressive enhancement of the one Shopify contact form. */
(function () {
  function enquiryType(value) {
    var topic = value.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    if (/\b(prisons?|build to bond)\b/.test(topic)) return 'prison programme';
    if (/\b(schools?|colleges?|community|education|councils?)\b/.test(topic)) return 'schools & community';
    if (topic === 'work' || /\b(team days?|team ?build(?:ing)?|corporate)\b/.test(topic)) return 'team day';
    if (/\b(press|media)\b/.test(topic)) return 'press';
    if (topic === 'build' || /\b(kits?|workshops?)\b/.test(topic)) return 'kits & workshops';
    return '';
  }

  function init(root) {
    var section = root.querySelector('.bbc-rd-contact');
    if (!section) return;
    var form = section.querySelector('form');
    if (!form || form.dataset.enquiryReady) return;
    var select = form.elements.namedItem('contact[enquiry_type]');
    if (!select) return;
    form.dataset.enquiryReady = 'true';
    var params = new URLSearchParams(window.location.search);
    var subject = params.get('subject') || '';
    var topic = params.get('topic') || '';
    ['subject', 'topic'].forEach(function (key) {
      var field = form.elements.namedItem('contact[' + key + ']');
      if (field && !field.value) field.value = params.get(key) || '';
    });
    // A restored or server-returned choice wins. Unknown context stays in the payload.
    if (!select.value && (subject.trim() || topic.trim())) {
      select.value = enquiryType(subject) || enquiryType(topic) || 'other';
    }
    section.addEventListener('click', function (event) {
      var link = event.target.closest('a[data-enquiry-type]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      select.value = link.dataset.enquiryType;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      select.focus();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else { init(document); }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bbc-drawing-hero"] && !Shopify.designMode) return;
  try {
    
/* Why-bamboo hero film. Same hardened pattern as the impact hero: play() can
   resolve while the element is still paused at t=0, so start on `canplay` and
   reveal only on `playing`. Gates leave the still photo in place. */
(function () {
  var v = document.querySelector('.dvh-film');
  if (!v) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  /* phone gate removed 2026-08-24 - James: hero films must play on mobile too */
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;
  v.muted = true; v.defaultMuted = true;
  function start() {
    var p = v.play();
    if (p && p.catch) p.catch(function () { /* autoplay refused — photo stays */ });
  }
  v.addEventListener('playing', function () { v.classList.add('is-on'); }, { once: true });
  function go() {
    v.setAttribute('preload', 'auto');
    v.load();
    if (v.readyState >= 3) start();
    else v.addEventListener('canplay', start, { once: true });
  }
  /* 2026-09-23 (speed): start the film only after the page has loaded, so the hero photo is the
     largest paint and the ~3.5 MB film no longer competes with it. Films still play on phones. */
  function later() { setTimeout(go, 1200); }
  if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { v.pause(); }
    else if (v.classList.contains('is-on')) { start(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bbc-teambuilding-2026"] && !Shopify.designMode) return;
  try {
    
/* Team-building hero film. Same hardened pattern as impact/why-bamboo: play() can
   resolve while still paused at t=0, so start on `canplay` and reveal only on
   `playing`. Gates (reduced-motion / phones / save-data) leave the photo in place. */
(function () {
  var v = document.querySelector('.bbc-rd-tb .rd-hero .imp-film');
  if (!v) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  /* phone gate removed 2026-08-24 - James: hero films must play on mobile too */
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;
  v.muted = true; v.defaultMuted = true;
  function start() {
    var p = v.play();
    if (p && p.catch) p.catch(function () { /* autoplay refused - photo stays */ });
  }
  v.addEventListener('playing', function () { v.classList.add('is-on'); }, { once: true });
  function go() {
    v.setAttribute('preload', 'auto');
    v.load();
    if (v.readyState >= 3) start();
    else v.addEventListener('canplay', start, { once: true });
  }
  /* 2026-09-23 (speed): start the film only after the page has loaded, so the hero photo is the
     largest paint and the ~3.5 MB film no longer competes with it. Films still play on phones. */
  function later() { setTimeout(go, 1200); }
  if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { v.pause(); }
    else if (v.classList.contains('is-on')) { start(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bbc-workshops-2026"] && !Shopify.designMode) return;
  try {
    
/* Workshops hero film - the estate's hardened pattern. */
(function () {
  var v = document.querySelector('.wvh-film');
  if (!v) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  /* phone gate removed 2026-08-24 - James: hero films must play on mobile too */
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;
  v.muted = true; v.defaultMuted = true;
  function start() { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  v.addEventListener('playing', function () { v.classList.add('is-on'); }, { once: true });
  function go() {
    v.setAttribute('preload', 'auto');
    v.load();
    if (v.readyState >= 3) start();
    else v.addEventListener('canplay', start, { once: true });
  }
  /* 2026-09-23 (speed): start the film only after the page has loaded, so the hero photo is the
     largest paint and the ~3.5 MB film no longer competes with it. Films still play on phones. */
  function later() { setTimeout(go, 1200); }
  if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { v.pause(); }
    else if (v.classList.contains('is-on')) { start(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
